import { makeStyles } from '@material-ui/core'

export const useFileCardStyles = makeStyles(theme => ({
  list: {
    padding: 0,
    margin: 0
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    padding: '10px 16px',
    marginBottom: 12
  },
  fileDetails: {
    display: 'flex',
    alignItems: 'center'
  }
}))
